<div class="wallet-qris-interface-container">
  <div class="wallet-qris-interface-content">
    <div class="scanner-container">
      <ngx-scanner-qrcode
        #action
        [config]="config"
        (event)="onScanResult($event)"
      ></ngx-scanner-qrcode>
    </div>
    <div class="scanner-header">
      <h2>{{ "wallet_qris.title" | translate }}</h2>
      <p class="mb-24">
        {{ "wallet_qris.subtitle" | translate }}
      </p>
    </div>
    <div class="scanner-footer">
      <div class="action-buttons-container">
        <!-- Flash Button (Left) -->
        <button
          *ngIf="hasFlashSupport"
          type="button"
          class="action-button"
          (click)="toggleFlash()"
        >
          <div class="action-button-icon">
            <img
              [src]="isFlashOn ? './assets/images/icon/icon-flash-on.svg' : './assets/images/icon/icon-flash-off.svg'"
              [alt]="isFlashOn ? 'Flash On' : 'Flash Off'"
            />
          </div>
          <span class="action-button-label">
            {{ isFlashOn ? 'Flash On' : 'Flash Off' }}
          </span>
        </button>

        <!-- Spacer when no flash support -->
        <div *ngIf="!hasFlashSupport" class="action-button-spacer"></div>

        <!-- Upload Button (Right) -->
        <button
          type="button"
          class="action-button"
          (click)="triggerFileUpload()"
        >
          <div class="action-button-icon">
            <img
              src="./assets/images/icon/icon-upload.svg"
              alt="Unggah"
            />
          </div>
          <span class="action-button-label">
            Unggah
          </span>
        </button>
      </div>

      <!-- Hidden File Input -->
      <input
        #fileInput
        type="file"
        accept="image/*"
        style="display: none;"
        (change)="onFileSelected($event)"
      />
    </div>
  </div>
</div>

<!-- Loading Overlay -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner" data-cy="loading-spinner">
    <p-progress-spinner
      data-cy="progress-spinner"
      fill="transparent"
      animationDuration="1s"
      styleClass="spinner-green"
      [style]="{ width: '32px', height: '32px' }"
    />
  </div>
</div>

<!-- Invalid QRIS Bottomsheet -->
<div *ngIf="isInvalidQRIS" class="bottomsheet-overlay">
  <div class="bottomsheet-container">
    <div class="bottomsheet-content">
      <img
        src="./assets/images/illust/il-qris-error.svg"
        alt="Error Qris"
      />
      <ng-container>
        <h2>
          {{ "wallet_qris.error_title" | translate }}
        </h2>
        <p>
          {{ "wallet_qris.error_subtitle" | translate }}
        </p>
        <button
          type="button"
          class="paper-button blue-button w-100"
          (click)="clearState()"
        >
          {{ "wallet_qris.error_action" | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Gallery Permission Denied Bottomsheet -->
<div *ngIf="showGalleryPermissionDenied" class="bottomsheet-overlay">
  <div class="bottomsheet-container">
    <div class="bottomsheet-content">
      <ng-container>
        <h2>
          Izinkan Akses Galeri
        </h2>
        <p>
          Agar bisa mengunggah dokumen atau memindai QR, kami butuh izin untuk mengakses galeri. Anda bisa mengaturnya di Pengaturan perangkat.
        </p>
        <button
          type="button"
          class="paper-button blue-button w-100"
          (click)="openDeviceSettings()"
        >
          Buka Pengaturan
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- QR Not Found Bottomsheet -->
<div *ngIf="showQRNotFound" class="bottomsheet-overlay">
  <div class="bottomsheet-container">
    <div class="bottomsheet-content">
      <img
        src="./assets/images/illust/il-qris-error.svg"
        alt="QR Not Found"
      />
      <ng-container>
        <h2>
          Kode QR Tidak Ditemukan
        </h2>
        <p>
          Gambar yang dipilih tidak mengandung kode QR yang valid. Silakan coba gambar lain.
        </p>
        <button
          type="button"
          class="paper-button blue-button w-100"
          (click)="clearQRNotFoundState()"
        >
          Coba Lagi
        </button>
      </ng-container>
    </div>
  </div>
</div>
